<template>
  <!-- 个人中心首页页面 -->
  <div id="sd-userinfo">
    <div class="userinfo-box">
      <!--<img src="../../assets/img/askdoctor/banner-GIF.gif" @click="goRouter('SdAskDoctor')" alt="" class="ask-gif">-->

      <img src="@/assets/img/icon/bindwx.png" alt="" class="bindwx" @click="bindwx" v-if="isLogin">
      <header>
        <div class="my-icon-box" @click="isLogin ? goRouter('/croppa') : goRouter('/SdLogin')">
          <img :src="avatar" alt="" class="my-icon">
        </div>
        <!-- 登录时 -->
        <div class="id-text" v-if="isLogin">
          <span class="text-cut">{{ userName || userInfo.mobile }}</span>
          <div class="edit-info">
            <!-- <span class="bind-wx-btn" @click="bindwx">绑定微信</span> -->
            <span @click="goRouter('SdEditInfo')">编辑个人信息</span>
            <pre style="display: inline-block">></pre>
          </div>
        </div>
        <!-- 未登录时 -->
        <div class="id-text" v-if="!isLogin" @click="goRouter('/SdLogin')">
          <span>登录/注册</span>
          <div class="edit-info">立即登录，解锁更多实用功能！</div>
        </div>
        <div class="user-msg" @click="goRouter('SdUserMsg')" v-if="showMsgBtn && !inMiniProgram">
          <img src="../../assets/img/login-img/xiaoxi-@2x.png" alt="">
          <i v-if="newsCount > 0" class="msgDom"></i>
        </div>
      </header>
      <nav class="nav" v-if="!inMiniProgram">
        <div class="list-item" @click="goRouter('SdVideoHistory')">
          <img src="../../assets/img/login-img/guangkanlishi@2x.png" alt="" class="item-icon">
          <span class="item-name">
            历史
            <span class="userData">{{ navData ? navData.history : ''}}</span>
          </span>
        </div>
        <i class="iscolumn">|</i>
        <div class="list-item" @click="goRouter('SdVideoCollect')">
          <img src="../../assets/img/login-img/shoucangshipin@2x.png" alt="" class="item-icon">
          <span class="item-name">
            收藏
            <span class="userData">{{ navData ? navData.collect : ''}}</span>
          </span>
        </div>
        <i class="iscolumn">|</i>
        <div class="list-item" @click="goRouter('SdHealthFile')">
          <img src="../../assets/img/login-img/jiankangdangan@2x.png" alt="" class="item-icon">
          <span class="item-name">
            档案
            <span class="userData">{{ navData ? navData.record : ''}}</span>
          </span>
        </div>
      </nav>
      <!-- 信息列表 -->
      <div class="msg-list">
        <ul class="list-wrapper">
          <li class="list-item item-flag" @click="goRouter('SdAskOrder')" v-if="!inMiniProgram">
            <div class="item-left">
              <img src="../../assets/img/login-img/wenzhen-@2x.png" alt="" class="item-icon">
              <span class="item-name">问诊咨询</span>
              <div class="number-box" v-if="totalNum>0">
                <span class="box-wrapper">{{totalNum}}</span>
              </div>
            </div>
            <div class="item-right">
              <img src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
            </div>
          </li>
          <li class="list-item item-flag" @click="goRouter('/hasBuyHistory')" v-if="!inMiniProgram">
            <div class="item-left">
              <img src="../../assets/img/login-img/hasBuyed.png" alt="" class="item-icon">
              <span class="item-name">已购视频</span>
            </div>
            <div class="item-right">
              <img src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
            </div>
          </li>
          <li class="list-item item-flag" @click="goRouter('SdLikeDoctor')" v-if="!inMiniProgram">
            <div class="item-left">
              <img src="../../assets/img/login-img/wenzhenzixun@2x.png" alt="" class="item-icon">
              <span class="item-name">我的医生</span>
            </div>
            <div class="item-right">
              <img src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
            </div>
          </li>
          <li class="list-item" @click="goRouter('/SdGetInvoice')" v-if="!inMiniProgram">
            <div class="item-left">
              <img src="../../assets/img/login-img/bill.png" alt="" class="item-icon">
              <span class="item-name">开具发票</span>
            </div>
            <div class="item-right">
              <img src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
            </div>
          </li>
          <!-- 小程序环境下 -->
          <li class="list-item" @click="goRouter('SdVideoHistory')" v-if="inMiniProgram">
            <div class="item-left">
              <img src="../../assets/img/login-img/guangkanlishi@2x.png" alt="" class="item-icon">
              <span class="item-name">观看历史</span>
            </div>
            <div class="item-right">
              <img src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
            </div>
          </li>
          <li class="list-item" @click="goRouter('SdVideoCollect')" v-if="inMiniProgram">
            <div class="item-left">
              <img src="../../assets/img/login-img/shoucangshipin@2x.png" alt="" class="item-icon">
              <span class="item-name">我的收藏</span>
            </div>
            <div class="item-right">
              <img src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
            </div>
          </li>
          <!-- 小程序环境下↑ -->
          <li class="list-item" @click="goRouter('joinUs')">
            <div class="item-left">
              <img src="../../assets/img/login-img/lianxiwomen@2x.png" alt="" class="item-icon">
              <span class="item-name">联系深读</span>
            </div>
            <div class="item-right">
              <img src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
            </div>
          </li>
        </ul>
      </div>
      <!-- end -->
      <!-- 退出button -->
      <div class="out-button-box" v-if="isLogin">
        <van-button size="large" class="out-button" @click="outLogin">
          <span>退出登录</span>
        </van-button>
      </div>
    </div>
    <app-nav></app-nav>
  </div>
</template>

<script>
  // import VConsole from "vconsole/dist/vconsole.min.js";
  import iMp from "@/common/isMp";
  import { currentHost } from "@/config";
  import SdNav from "../../components/shenduNav/SdNav";
  import api from "@/api/index";
  export default {
    components: {
      "app-nav": SdNav
    },
    data() {
      return {
        userInfo: {},
        totalNum: null,
        newsCount: 0,
        navData: [],
        showMsgBtn: true, // 消息功能，尚未完善(需求是 不要跟订单同步)
        isLogin: this.$isLogin()
      };
    },
    mixins: [iMp],
    computed: {
      avatar() {
        if (this.isLogin) {
          return this.$store.getters.defaultUserAvatar;
        } else {
          return require("@/assets/img/see-doctor-icon/1-3pingluntouxiang@2x.png");
        }
      },
      userName() {
        return this.$store.state.userStore.userName;
      }
    },
    created() {
      this.getTotal();
      this.$isLogin() ? this.fetch() : "";
      // this.fetch();
      this.getNavData();
    },
    beforeMount() {},
    mounted() {
      // let vConsole = new VConsole();
      this.checkOauth();
    },
    methods: {
      // 历史收藏档案
      getNavData() {
        this.$http.post(api.centerTj).then(res => {
          this.navData = res.data.data;
        });
      },
      goRouter(router) {
        this.$router.push(router);
      },
      outLogin() {
        let url = api.logout;
        this.$http.post(url).then(res => {
          if (res.data.code == 0) {
            this.isLogin = false;
            localStorage.clear();
            sessionStorage.clear();
            this.$store.dispatch("actionAvatar", "");
            this.navData = null;
            this.$toast("操作成功");
            // this.$router.push("/SdSeeDoctor");
          } else {
            // this.$router.push('SdLogin')
            this.$toast(res.data.message);
          }
        });
      },
      fetch() {
        let url = api.getUserInfo;
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            res.data.data.avatar && res.data.data.avatar.trim()
              ? sessionStorage.setItem(
                  "useravatar",
                  currentHost + res.data.data.avatar
                )
              : "";
            this.$store.commit("mutationAvatar", res.data.data.avatar);
            this.$store.commit("mutationName", res.data.data.nickname);
            this.userInfo = res.data.data;
            this.newsCount = res.data.data.newsCount;
            localStorage.setItem("userInfo", JSON.stringify(res.data.data));
            localStorage.setItem("uid", res.data.data.uid);
          }
        });
      },
      checkOauth() {
        if (
          sessionStorage.getItem("isOauth") &&
          sessionStorage.getItem("isOauth") == 1
        ) {
          this.bindwx();
          sessionStorage.setItem("isOauth", 0);
        } else {
        }
      },
      bindwx() {
        if (
          localStorage.getItem("isMp") == "noIsWxH5" ||
          localStorage.getItem("isMp") == "yes"
        ) {
          this.$http.get(api.bindwx).then(res => {
            if (res.data.code == 0) {
              this.$toast("绑定成功！");
            } else {
              this.$toast("正在授权...");
              this.getOpenId();
              sessionStorage.setItem("isOauth", 1);
            }
          });
        } else {
          this.$toast({
            message: "抱歉，此功能需在微信端使用",
            duration: 1000
          });
        }
      },
      getOpenId() {
        return new Promise((resolve, reject) => {
          let http = window.location.href;
          console.log("getUserInfo openid http2", http);
          if (http.indexOf("openid") > -1) {
            let openid = http.split("openid")[1].split("#")[0];
            if (openid) {
              let id = openid.split("=")[1];
              localStorage.setItem("openid", id);
              return id;
              console.log("临时解决方案get openid", id);
            }
            next();
          } else {
            // let url = http.split("/")[1];
            window.location.href = location.origin + `/wx/tz?url=SdUserInfo`;
          }
          resolve(http);
        });
      },
      getTotal() {
        let url = api.wdxx;
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.totalNum = res.data.data;
          }
        });
      }
    }
  };
</script>

<style lang="postcss" scoped>
  #sd-userinfo {
    & .text-cut {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    background-color: #fffffd;
    height: 100%;
    width: 100%;
    /* padding-bottom: 250px; */
    /* padding-bottom: 188px; */
    & .userinfo-box {
      height: 100%;
      padding: 0 30px;
      padding-bottom: 150px;
      & .bindwx {
        position: absolute;
        width: 123px;
        height: 40px;
        top: 110px;
        right: 0;
        z-index: 123;
      }
      & header {
        position: relative;
        display: flex;
        align-items: center;
        padding-top: 60px;
        padding-bottom: 30px;
        & .my-icon-box {
          height: 128px;
          width: 128px;
          border-radius: 50%;
          overflow: hidden;
          background-color: #e1e2e6;
          & .my-icon {
            height: 128px;
            width: 128px;
          }
        }
        & .id-text {
          margin-left: 50px;
          font-size: 48px;
          color: #333333;
          font-family: "Source Han Sans CN";
          font-weight: bold;
          & .edit-info {
            color: #666666;
            font-size: 24px;
            font-weight: 400;
            margin-top: 19px;
            & .bind-wx-btn {
              color: #37bd19;
              margin-right: 20px;
            }
          }
        }
        & .user-msg {
          position: absolute;
          right: 0px;
          top: 22px;
          & img {
            width: 34px;
          }
          & .msgDom {
            position: absolute;
            top: -1px;
            right: -4px;
            width: 1px;
            height: 1px;
            display: block;
            background-color: #ff0000;
            border-radius: 50%;
            border: 6px solid #f43531;
          }
        }
      }
      & .nav::after {
        position: absolute;
        bottom: 0;
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        border: 1px solid rgba(215, 215, 215, 1);
        transform: scaleY(0.3);
      }
      & .nav {
        position: relative;
        display: flex;
        justify-content: space-around;
        padding-top: 28px;
        & .iscolumn {
          width: 1px;
          height: 30px;
          font-size: 0;
          background-color: #d7d7d7;
          margin-top: 20px;
        }
        & .list-item {
          display: flex;
          flex-direction: column;
          flex: 1;
          align-items: center;
          & img {
            width: 64px;
            height: 64px;
          }
          & .item-name {
            margin-top: 20px;
            font-size: 26px;
            padding-bottom: 50px;
            & .userData {
              color: #37bd19;
            }
          }
        }
      }
      & .msg-list {
        & .list-wrapper {
          /* margin-bottom: 500px; */
          & .ask-gif {
            width: 100%;
          }
          & .list-item {
            margin: 80px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            & .item-left {
              display: flex;
              align-items: center;
              & .item-icon {
                margin-right: 30px;
                width: 38px;
                height: 38px;
              }
              & .item-name {
                font-size: 30px;
                color: #333333;
                font-family: "Source Han Sans";
              }
            }
            & .item-right {
              & .more-icon {
                width: 15px;
                height: 30px;
              }
            }
          }
          & .item-flag {
            position: relative;
          }
        }
        /* 加gif之后的顶部间距 */
        & .list-wrapper:first-child li {
          margin-top: 60px;
        }
      }
      & .out-button-box {
        width: 100%;
        height: 75px;
        display: flex;
        border: 1.1px solid rgba(215, 215, 215, 1);
        border-radius: 40px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        /* margin-bottom: 150px; */
        & .out-button {
          width: 100%;
          height: 75px;
          background-color: #fffffd;
          font-size: 32px;
          font-family: SourceHanSansCN-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          border-radius: 40px;
        }
      }
    }
    & .number-box {
      position: absolute;
      border: 3px solid #f43531;
      border-radius: 50%;
      background-color: #f43531;
      height: 36px;
      width: 36px;
      color: white;
      font-size: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      bottom: 4px;
      right: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shenduUserInfo/SdUserInfo.vue